export const loadBitrixScript = () => {
  return new Promise((resolve, reject) => {
    if (window.BX24) {
      resolve(window.BX24);
      return;
    }

    let script = document.getElementById("bitrix24-api-script");
    if (script) {
      script.addEventListener("load", () => resolve(window.BX24));
      script.addEventListener("error", (err) => reject(err));
      return;
    }

    script = document.createElement("script");
    script.id = "bitrix24-api-script";
    script.src = "//api.bitrix24.tech/api/v1/";
    script.async = true;

    script.onload = () => resolve(window.BX24);
    script.onerror = (err) => reject(err);

    document.head.appendChild(script);
  });
};
